import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import projectService from "./projectService";

// Get all projects
export const getProjects = createAsyncThunk(
  "project/get-projects",
  async (_, thunkAPI) => {
    try {
      return await projectService.getProjects();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

 
// Reset state
export const resetState = createAction("Reset_all");

const initialState = {
  projects: [],
  

  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // ===== GET PROJECTS =====
      .addCase(getProjects.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.projects = action.payload;
      })
      .addCase(getProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error;
      })
 
      // ===== RESET =====
      .addCase(resetState, () => initialState);
  },
});

export default projectSlice.reducer;
